import { createI18n } from 'vue-i18n'
import storage from '@/libs/storage';

import enUs from './en-us.json'
import zhCn from './zh-cn.json'

const messages = {
	'en-us': enUs,
	'zh-cn': zhCn
}

let locale = '';
if(storage.get("lang",null)){
  locale = storage.get("lang",null);
}else{
  // 检查浏览器语言类型 
  let browserLang = navigator.language.toLowerCase();
  if(browserLang == 'zh-cn'){
    locale = browserLang;
  }else{
    locale = 'en-us';
  }

  // 保存浏览器语言标识
  storage.set("lang",locale);
}

export default createI18n({
  locale: locale,
  fallbackLocale: 'zh-cn',
  messages,
  silentTranslationWarn: true
});